<template>
    <div class="modal fade fill-in in" 
        :id="modalId" 
        tabindex="-1" 
        role="dialog" 
        :aria-labelledby="modalId + 'Label'" 
        aria-hidden="false" 
        style="display: block; padding-right: 15px;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="onExit">
            <i class="pg-close"></i>
        </button>

        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h5>{{ modalTitle }}</h5>
                        </div>

                        <div class="panel-body">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },

        props: {
            modalId: {
                type: String,
                required: true
            },
            modalTitle: {
                type: String,
                default: ''
            }
        },

        methods: {
            closeModal() {
                this.$emit('modal-closed', this.modalId)
            },

            onExit() {
                this.closeModal()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal.fade.fill-in.in {
        background-color: rgba(0, 0, 0, 0.75);
    }

    .pg-close:before {
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// client/components/Modals/FillInModal.vue